import React from 'react';
import PortalsRenderer from 'modules/shared/components/portals-renderer';
import FloatingWindowsRenderer from 'modules/shared/components/floating-windows-renderer';
import SlidingLayersRenderer from 'modules/shared/components/sliding-layers-renderer';
import Toasters from 'modules/shared/components/toasters';
import Snackbars from 'modules/shared/components/snackbars';
import CacheClearWarning from 'modules/shared/components/cache-clear-warning';
import MasterPagesManager from 'master-pages/components/master-pages-manager';
import PbxDialer from './modules/contacts/components/pbx-dialer';
import ContactDetailsManager from './modules/contacts/components/contact-details-manager';

function App() {
    return (
        // the list of JSX component that must be always render-able, regardless what is in DOM
        <>
            <CacheClearWarning />
            <PortalsRenderer />
            <FloatingWindowsRenderer />
            <SlidingLayersRenderer />
            <Toasters />
            <Snackbars />
            <PbxDialer />
            <MasterPagesManager />
            <ContactDetailsManager />
        </>
    );
}

export default App;
